import React from 'react';
import { compose } from 'redux';
import { Link, Redirect } from 'react-router-dom';

import Pagination from '../components/Pagination/Pagination';
import UserPaymentMethodList from '../components/UserPaymentMethodList/UserPaymentMethodList';
import UserPaymentMethodECheckList from '../components/UserPaymentMethodList/UserPaymentMethodECheckList';
import userPage from '../decorators/userPage';
import CreatePaymentMethod from './CreatePaymentMethod';
import withPurchaseMethods from '../decorators/withPurchaseMethods';
import { can, permActions } from 'permissions';

const UserPaymentMethods = ({
  user,
  userId,
  loggedInUser,
  paymentMethods,
  pageCount,
  page,
  fetchUserPaymentMethods,
}) => {
  if (!user || !loggedInUser) {
    return <div>Loading...</div>;
  }

  let echeckMethods = [];
  let cardMethods = [];
  paymentMethods.forEach((method) => {
    if (method.echeck_type) {
      echeckMethods.push(method);
    } else {
      cardMethods.push(method);
    }
  });

  const showEcheck = user?.acl_group_name === 'BUSINESS';
  const showUpdateEcheckMethod =
    Boolean(echeckMethods.length) &&
    can(loggedInUser, permActions.UPDATE_PAYMENT_METHOD);
  const showUpdatePaymentMethod =
    Boolean(cardMethods.length) &&
    can(loggedInUser, permActions.UPDATE_PAYMENT_METHOD);
  const showCreatePaymentMethod = can(
    loggedInUser,
    permActions.CREATE_PAYMENT_METHOD,
  );
  const showPaymentMethods = can(
    loggedInUser,
    permActions.VIEW_PAYMENT_METHODS,
  );

  if (!showPaymentMethods) {
    return <Redirect to={`/users/${userId}/view`} />;
  }

  return (
    <div>
      {showEcheck && (
        <React.Fragment>
          <h2>ECheck Payment Methods</h2>
          <UserPaymentMethodECheckList
            list={echeckMethods}
            user={user}
            page={page}
            fetchUserPaymentMethods={fetchUserPaymentMethods}
            loggedInUser={loggedInUser}
          />
          {showUpdateEcheckMethod && (
            <Link to={`/users/${userId}/payment-methods/update-echeck`}>
              Update payment profile
            </Link>
          )}
        </React.Fragment>
      )}
      <h2>Payment Methods</h2>
      <UserPaymentMethodList
        list={cardMethods}
        user={user}
        page={page}
        fetchUserPaymentMethods={fetchUserPaymentMethods}
        loggedInUser={loggedInUser}
      />
      {showUpdatePaymentMethod && (
        <Link to={`/users/${userId}/payment-methods/update`}>
          Update payment profile
        </Link>
      )}
      <Pagination
        count={pageCount}
        current={page}
        url={(pageNum) => `/users/${userId}/payment-methods?page=${pageNum}`}
      />
      {showCreatePaymentMethod && (
        <CreatePaymentMethod
          user={user}
          onSuccess={() => user && fetchUserPaymentMethods(user.id, page)}
        />
      )}
    </div>
  );
};

export default compose(userPage, withPurchaseMethods)(UserPaymentMethods);
